import styled from "styled-components";
import { CSSProperties, ReactNode } from "react";

type Props = {
  children?: ReactNode;
  style?: CSSProperties;
};

export const InputButtonGroup = styled.div<Props>`
  display: flex;

  .k-input {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: 0;
  }

  .k-button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`;
